(function () {
  // When a visitor hits "back" from checkout, the browser can restore this page
  // from bfcache instead of reloading it — meaning the DOM stays frozen exactly
  // as it was mid-navigation (Add to Cart button stuck on "Adding...", cart icon
  // showing stale/pre-add counts). Force a real reload in that case so the page
  // re-renders with current cart state.
  window.addEventListener('pageshow', function (event) {
    if (event.persisted) {
      window.location.reload();
    }
  });

  var scripts = document.querySelectorAll('[id^="ww-buybox-"]');
  scripts.forEach(initHeroBuybox);

  function initHeroBuybox(root) {
    var sid = root.id.replace('ww-buybox-', '');

    var mainImg = document.getElementById('ww-gallery-active-img-' + sid);
    // Shopify's image_tag helper renders a srcset attribute, and browsers prefer
    // srcset over src when both are present — so a plain .src swap is silently
    // ignored unless we also clear srcset/sizes here.
    function setMainImage(url) {
      if (!mainImg || !url) return;
      mainImg.removeAttribute('srcset');
      mainImg.removeAttribute('sizes');
      mainImg.src = url;
    }
    // Photo gallery: thumbnail click, prev/next arrows, dots, and touch swipe
    // all drive the same index so they stay in sync with each other.
    var galleryThumbs = Array.prototype.slice.call(root.querySelectorAll('.ww-thumb'));
    var galleryUrls = galleryThumbs.map(function (t) { return t.getAttribute('data-full'); });
    var galleryDots = Array.prototype.slice.call(root.querySelectorAll('.ww-gallery-dot'));
    var galleryIndex = 0;

    function goToGalleryIndex(i) {
      if (!galleryUrls.length) return;
      galleryIndex = (i + galleryUrls.length) % galleryUrls.length;
      setMainImage(galleryUrls[galleryIndex]);
      galleryThumbs.forEach(function (t, idx) { t.classList.toggle('active', idx === galleryIndex); });
      galleryDots.forEach(function (d, idx) { d.classList.toggle('active', idx === galleryIndex); });
      var activeThumb = galleryThumbs[galleryIndex];
      if (activeThumb && activeThumb.scrollIntoView) {
        activeThumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      }
    }

    galleryThumbs.forEach(function (thumb, idx) {
      thumb.addEventListener('click', function () { goToGalleryIndex(idx); });
    });
    galleryDots.forEach(function (dot, idx) {
      dot.addEventListener('click', function () { goToGalleryIndex(idx); });
    });

    var galleryPrevBtn = document.getElementById('ww-gallery-prev-' + sid);
    var galleryNextBtn = document.getElementById('ww-gallery-next-' + sid);
    if (galleryPrevBtn) galleryPrevBtn.addEventListener('click', function () { goToGalleryIndex(galleryIndex - 1); });
    if (galleryNextBtn) galleryNextBtn.addEventListener('click', function () { goToGalleryIndex(galleryIndex + 1); });

    var galleryMain = document.getElementById('ww-gallery-main-' + sid);
    if (galleryMain) {
      var touchStartX = null;
      var touchStartY = null;
      galleryMain.addEventListener('touchstart', function (e) {
        if (!e.touches || !e.touches.length) return;
        touchStartX = e.touches[0].clientX;
        touchStartY = e.touches[0].clientY;
      }, { passive: true });
      galleryMain.addEventListener('touchend', function (e) {
        if (touchStartX === null) return;
        var touch = (e.changedTouches && e.changedTouches[0]) || null;
        touchStartX = touchStartX === null ? null : touchStartX;
        if (!touch) return;
        var dx = touch.clientX - touchStartX;
        var dy = touch.clientY - (touchStartY || 0);
        touchStartX = null;
        touchStartY = null;
        if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;
        if (dx < 0) goToGalleryIndex(galleryIndex + 1);
        else goToGalleryIndex(galleryIndex - 1);
      }, { passive: true });
    }

    // Countdown (persists across page loads for the configured window, resets after it expires)
    var countdownEl = document.getElementById('ww-countdown-' + sid);
    if (countdownEl) {
      var DURATION = (parseInt(root.getAttribute('data-countdown-minutes'), 10) || 20) * 60 * 1000;
      // Shared (not per-section) key so the cart drawer's countdown — a
      // separate global component — reads the exact same running timer,
      // instead of each starting its own clock and drifting out of sync.
      var KEY = 'ww_hero_timer';
      var start = parseInt(localStorage.getItem(KEY), 10);
      if (!start || isNaN(start) || (Date.now() - start) > DURATION) {
        start = Date.now();
        localStorage.setItem(KEY, start);
      }
      var pad = function (n) { return n < 10 ? '0' + n : '' + n; };
      var tick = function () {
        var remaining = DURATION - (Date.now() - start);
        if (remaining <= 0) {
          start = Date.now();
          localStorage.setItem(KEY, start);
          remaining = DURATION;
        }
        var mins = Math.floor(remaining / 60000);
        var secs = Math.floor((remaining % 60000) / 1000);
        countdownEl.textContent = pad(mins) + ':' + pad(secs);
        setTimeout(tick, 1000);
      };
      tick();
    }

    // Variant data — resolves the real Shopify variant, no fabricated data
    var variantScript = document.getElementById('ww-variants-' + sid);
    var variants = variantScript ? JSON.parse(variantScript.textContent) : [];
    var productOptions = (function () {
      var s = document.getElementById('ww-options-' + sid);
      return s ? JSON.parse(s.textContent) : [];
    })();

    function findVariantBySelections(sel) {
      return variants.find(function (v) {
        return sel.every(function (val, i) {
          var key = 'option' + (i + 1);
          return val == null || v[key] === val;
        });
      });
    }

    function openSizeChart() {
      var modalId = root.getAttribute('data-size-chart-modal-id') || 'ww-size-chart-modal';
      var modal = document.getElementById(modalId);
      if (modal && typeof modal.showModal === 'function') modal.showModal();
      else if (modal) modal.setAttribute('open', '');
    }

    var COLOR_HEX = [
      ['purple', '#8B5FBF'], ['yellow', '#FFC94D'], ['blue', '#2E9FE0'], ['pink', '#F4A6C6'],
      ['red', '#E8352B'], ['green', '#4CAF7D'], ['black', '#1A1A1A'], ['white', '#FFFFFF'],
      ['grey', '#9CA3AF'], ['gray', '#9CA3AF'], ['cream', '#F2E8D5'], ['beige', '#F2E8D5'],
      ['tan', '#D8C3A5']
    ];
    function colorHexFor(name) {
      var n = (name || '').toLowerCase();
      for (var i = 0; i < COLOR_HEX.length; i++) {
        if (n.indexOf(COLOR_HEX[i][0]) !== -1) return COLOR_HEX[i][1];
      }
      return '#CBD5C0';
    }
    function buildOptionGroup(opt, currentVal, onChange) {
      var group = document.createElement('div');
      group.className = 'ww-option-group';
      var labelRow = document.createElement('div');
      labelRow.className = 'ww-option-label';
      var labelSpan = document.createElement('span');
      labelSpan.textContent = opt.name + ': ';
      var valueSpan = document.createElement('span');
      valueSpan.className = 'ww-option-value';
      valueSpan.textContent = currentVal;
      labelSpan.appendChild(valueSpan);
      labelRow.appendChild(labelSpan);
      if (/size/i.test(opt.name)) {
        var chartLink = document.createElement('button');
        chartLink.type = 'button';
        chartLink.className = 'ww-size-chart-link';
        chartLink.textContent = '📏 Size Chart';
        chartLink.addEventListener('click', openSizeChart);
        labelRow.appendChild(chartLink);
      }
      group.appendChild(labelRow);
      var valuesRow = document.createElement('div');
      valuesRow.className = 'ww-option-values';
      var isColor = /color|colour/i.test(opt.name);
      opt.values.forEach(function (val) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.setAttribute('data-value', val);
        if (isColor) {
          btn.className = 'ww-swatch' + (val === currentVal ? ' active' : '');
          var dot = document.createElement('span');
          dot.className = 'ww-swatch-dot';
          dot.style.background = colorHexFor(val);
          var nameEl = document.createElement('span');
          nameEl.className = 'ww-swatch-name';
          nameEl.textContent = val;
          btn.appendChild(dot);
          btn.appendChild(nameEl);
        } else {
          btn.className = 'ww-pill' + (val === currentVal ? ' active' : '');
          btn.textContent = val;
        }
        btn.addEventListener('click', function () {
          valuesRow.querySelectorAll('button').forEach(function (b) { b.classList.remove('active'); });
          btn.classList.add('active');
          valueSpan.textContent = val;
          onChange(val);
        });
        valuesRow.appendChild(btn);
      });
      group.appendChild(valuesRow);
      return group;
    }

    // Every bundle tier (1/2/3 vests) gets its own nested container holding a
    // picker per vest in that tier — including vest 1. Only the container for
    // whichever tier is currently selected is shown.
    var kitUnitContainers = root.querySelectorAll('.ww-kit-units');
    var unitPickers = [];

    function updateMainImageFromSelections(selections) {
      var v = findVariantBySelections(selections);
      if (v && v.featured_image) {
        setMainImage(v.featured_image.src.replace(/(\.[a-z]+)(\?|$)/i, '_1000x$1$2'));
      }
    }

    function updateMainImageFromUnit1() {
      if (!unitPickers[0]) return;
      updateMainImageFromSelections(unitPickers[0].selections);
    }

    function updateAddBtnState() {
      var addBtn = document.getElementById('ww-add-' + sid);
      if (!addBtn) return;
      var ok = unitPickers.length > 0;
      unitPickers.forEach(function (u) {
        var v = findVariantBySelections(u.selections);
        if (!v || v.available === false) ok = false;
      });
      addBtn.disabled = !ok;
    }

    // Shopify always returns at least one option for a product — single-variant
    // products get a synthetic "Title"/"Default Title" option rather than an empty
    // array — so a plain `.length` check never catches the true single-variant case.
    // Filter that placeholder out before deciding whether there's any real picker UI.
    var realProductOptions = productOptions.filter(function (o) {
      return !(productOptions.length === 1 && o.name === 'Title');
    });

    function renderUnitPickers(qty) {
      kitUnitContainers.forEach(function (el) {
        el.style.display = 'none';
        el.innerHTML = '';
      });
      unitPickers = [];
      if (!realProductOptions.length) {
        // True single-variant product (no real options, e.g. "Default Title" only) —
        // no picker UI to show, but Add to Cart still needs a variant to add per unit.
        // An empty selections array trivially matches the product's one variant.
        for (var n = 0; n < qty; n++) { unitPickers.push({ selections: [] }); }
        updateAddBtnState();
        return;
      }
      var wrap = root.querySelector('.ww-kit-units[data-for-qty="' + qty + '"]');
      if (!wrap) { updateAddBtnState(); return; }
      wrap.style.display = (qty === 2) ? 'grid' : 'flex';
      // Some products (e.g. a bath stand with only a Color option) have nothing to
      // "size" at all, so the sizing helper sentence is opt-out via this attribute
      // rather than a shared default every section has to remember to override.
      if (root.getAttribute('data-hide-size-helper') !== 'true') {
        var helper = document.createElement('div');
        helper.className = 'ww-size-helper';
        helper.textContent = root.getAttribute('data-size-helper') || "Measure your dog's chest (widest part, behind the front legs). Between sizes? Size up.";
        wrap.appendChild(helper);
      }
      var unitLabel = root.getAttribute('data-unit-label') || 'Vest';
      var addUnit = function (unitNumber) {
        var box = document.createElement('div');
        box.className = 'ww-unit-picker';
        var label = document.createElement('div');
        label.className = 'ww-unit-picker-label';
        label.textContent = unitLabel + ' ' + unitNumber;
        box.appendChild(label);
        var sel = realProductOptions.map(function (o) { return o.values[0]; });
        var unavail = document.createElement('div');
        unavail.className = 'ww-variant-unavailable';
        unavail.style.display = 'none';
        unavail.textContent = 'That combination is currently out of stock — try another size or color.';
        realProductOptions.forEach(function (opt, i) {
          var group = buildOptionGroup(opt, sel[i], function (val) {
            sel[i] = val;
            var v = findVariantBySelections(sel);
            unavail.style.display = (v && !v.available) ? 'block' : 'none';
            // Any unit's color choice should be reflected in the hero photo, not
            // just the first one — a shopper picking Pink for unit 2 still wants
            // to see the pink stand, even though unit 1 stays Blue.
            updateMainImageFromSelections(sel);
            updateAddBtnState();
          });
          box.appendChild(group);
        });
        box.appendChild(unavail);
        wrap.appendChild(box);
        unitPickers.push({ selections: sel });
      };
      for (var u = 1; u <= qty; u++) { addUnit(u); }
      // Deliberately no auto-image-update here: the hero photo should keep
      // showing the curated gallery image (e.g. the lifestyle shot) on load
      // and on tier switches — it only changes once the shopper actively
      // picks a color, via the onChange handler above.
      updateAddBtnState();
    }

    var initialQty = (function () {
      var checked = root.querySelector('.ww-kit input[type="radio"]:checked');
      return checked ? (parseInt(checked.closest('.ww-kit').getAttribute('data-qty'), 10) || 1) : 1;
    })();
    renderUnitPickers(initialQty);

    // Size chart modal trigger
    var sizeChartTrigger = document.getElementById('ww-size-chart-trigger-' + sid);
    if (sizeChartTrigger) {
      sizeChartTrigger.addEventListener('click', openSizeChart);
    }

    var stickyPrice = document.getElementById('ww-sticky-price-' + sid);
    function updateStickyPrice() {
      var checked = root.querySelector('.ww-kit input[type="radio"]:checked');
      if (!checked || !stickyPrice) return;
      var totalEl = checked.closest('.ww-kit').querySelector('.ww-kit-total');
      if (totalEl) stickyPrice.textContent = totalEl.textContent;
    }
    root.querySelectorAll('.ww-kit input[type="radio"]').forEach(function (r) {
      r.addEventListener('change', function () {
        updateStickyPrice();
        var qty = parseInt(r.closest('.ww-kit').getAttribute('data-qty'), 10) || 1;
        renderUnitPickers(qty);
      });
    });

    function collectItems() {
      var checkedKit = root.querySelector('.ww-kit input[type="radio"]:checked');
      if (!checkedKit || unitPickers.length === 0) return [];
      var items = [];
      unitPickers.forEach(function (u) {
        var v = findVariantBySelections(u.selections);
        if (v) items.push({ id: v.id, quantity: 1 });
      });
      root.querySelectorAll('.ww-bump input[type="checkbox"]:checked').forEach(function (bump) {
        var vid = parseInt(bump.getAttribute('data-variant-id'), 10);
        if (vid) items.push({ id: vid, quantity: 1 });
      });
      // Some bundle tiers include a free ($0) gift, flagged via a data attribute
      // on the selected kit rather than going through the color/size unit pickers.
      var giftVariantId = parseInt(checkedKit.closest('.ww-kit').getAttribute('data-gift-variant-id'), 10);
      if (giftVariantId) items.push({ id: giftVariantId, quantity: 1 });
      return items;
    }

    function addToCart(btn) {
      var items = collectItems();
      if (items.length === 0) return;
      var orig = btn.textContent;
      btn.textContent = 'Adding...';
      btn.disabled = true;
      var drawerMode = root.getAttribute('data-cart-mode') === 'drawer';

      function sendAdd(finalItems) {
        var addPromise = drawerMode
          ? fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ items: finalItems })
            })
          : fetch('/cart/clear.js', { method: 'POST' }).then(function () {
              return fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ items: finalItems })
              });
            });

        addPromise
          .then(function (res) {
            if (!res.ok) throw new Error('add failed');
            btn.textContent = orig;
            btn.disabled = false;
            if (drawerMode && window.WWCartDrawer) {
              window.WWCartDrawer.open();
            } else {
              window.location.href = '/checkout';
            }
          })
          .catch(function () {
            btn.textContent = orig;
            btn.disabled = false;
            alert('Something went wrong. Please try again.');
          });
      }

      // Drawer mode (currently: life-vest buybox only) behaves like a normal
      // cart — items accumulate and the drawer lets the shopper adjust qty
      // or remove before checking out, so we don't clear first.
      //
      // Every other buybox always sends the shopper straight to checkout (no
      // cart review step), so if someone tries a different bundle/tries
      // again without completing checkout, a plain /cart/add.js would stack
      // on top of whatever's already in the cart (e.g. shipping protection
      // added twice). Clearing first makes each click represent the
      // *current* on-screen selection exactly, not an addition to a stale
      // cart.
      if (drawerMode) {
        // Accumulate-mode means clicking Add to Cart repeatedly (re-selecting
        // the bundle, changing color, checking a bump again, etc.) would
        // otherwise stack unlimited copies of one-time extras — the free
        // promo gift, Shipping Protection, or any other checked add-on — on
        // top of whatever's already in the cart. Unlike the actual product
        // (which should legitimately accumulate if you click again), these
        // are capped at 1: check what's actually in the cart first, and drop
        // any of them from this add call if already present.
        var cappedVariantIds = [];
        var checkedKit = root.querySelector('.ww-kit input[type="radio"]:checked');
        var giftVariantId = checkedKit ? parseInt(checkedKit.closest('.ww-kit').getAttribute('data-gift-variant-id'), 10) : null;
        if (giftVariantId) cappedVariantIds.push(giftVariantId);
        root.querySelectorAll('.ww-bump input[type="checkbox"]:checked').forEach(function (bump) {
          var vid = parseInt(bump.getAttribute('data-variant-id'), 10);
          if (vid) cappedVariantIds.push(vid);
        });

        if (cappedVariantIds.length) {
          fetch('/cart.js')
            .then(function (res) { return res.json(); })
            .then(function (cart) {
              var cartVariantIds = cart.items.map(function (item) { return item.variant_id; });
              var alreadyPresent = cappedVariantIds.filter(function (id) { return cartVariantIds.indexOf(id) !== -1; });
              var finalItems = alreadyPresent.length
                ? items.filter(function (it) { return alreadyPresent.indexOf(it.id) === -1; })
                : items;
              sendAdd(finalItems);
            })
            .catch(function () { sendAdd(items); });
        } else {
          sendAdd(items);
        }
      } else {
        sendAdd(items);
      }
    }

    var addBtn = document.getElementById('ww-add-' + sid);
    if (addBtn) {
      addBtn.addEventListener('click', function () { addToCart(addBtn); });
    }

    var stickyBar = document.getElementById('ww-sticky-' + sid);
    var stickyBtn = document.getElementById('ww-sticky-btn-' + sid);
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () { addToCart(stickyBtn); });
    }
    // The sticky "Add to Cart" bar only makes sense while the cart is empty — once
    // something's in it, the persistent floating cart icon (ww-persistent-cart.js)
    // is the right call-to-action, not a second, competing "add to cart" prompt.
    var addBtnScrolledPast = false;
    var stickyCartItemCount = 0;
    function refreshStickyVisibility() {
      if (!stickyBar) return;
      stickyBar.classList.toggle('ww-visible', addBtnScrolledPast && stickyCartItemCount === 0);
    }
    if (stickyBar && addBtn && 'IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          addBtnScrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          refreshStickyVisibility();
        });
      }, { threshold: 0 });
      observer.observe(addBtn);
    }
    document.addEventListener('ww:cart:updated', function (e) {
      stickyCartItemCount = (e.detail && typeof e.detail.item_count === 'number') ? e.detail.item_count : 0;
      refreshStickyVisibility();
    });
    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        stickyCartItemCount = cart.item_count;
        refreshStickyVisibility();
      })
      .catch(function () {});

    // Mini-FAQ accordion
    root.querySelectorAll('.ww-mf-item').forEach(function (item) {
      var q = item.querySelector('.ww-mf-q');
      q.addEventListener('click', function () { item.classList.toggle('open'); });
    });
  }
})();
